export default __webpack_public_path__ + "static/media/fad-cutter.3fb9fa1d.svg";